import SignInComponent from 'components/SignIn';

function SignIn() {
  return (
    <div className={'login-wrap'}>
      <SignInComponent />
    </div>
  );
}

export default SignIn;
